import React from 'react'
import { cpfCnpjMask } from '_/utils/helpers'
import { Grid } from '@material-ui/core'
import Chip from '_components/chip'
import CategoryIndicator from '_components/category-indicator'

const normalizeCities = cities => {
  if (!Array.isArray(cities) || cities.length === 0) return []

  return cities
    .map(city =>
      String(city || '')
        .replace(/_/g, ' ')
        .trim()
    )
    .filter(Boolean)
    .map(city => city.replace(/\b\w/g, letter => letter.toUpperCase()))
    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
}

const renderCitiesCell = cities => {
  const normalizedCities = normalizeCities(cities)

  if (normalizedCities.length === 0) return null

  if (normalizedCities.length > 1) {
    return (
      <Grid container alignItems="center">
        <Chip label={normalizedCities[0]} />
        <CategoryIndicator
          tooltipText={normalizedCities.join(', ').replace(/, ((?:.(?!, ))+)$/, ' e $1')}
          label={`+${normalizedCities.length - 1}`}
        />
      </Grid>
    )
  }

  return <Chip label={normalizedCities[0]} />
}

export const PROVIDER_COLUMNS = [
  {
    field: 'name',
    headerName: 'Nome da Empresa',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'cpfCnpj',
    headerName: 'CPF/CNPJ',
    width: 200,
    renderCell: ({ value }) => cpfCnpjMask(value || ''),
  },
  {
    field: 'cities',
    headerName: 'Cidades',
    flex: 1,
    minWidth: 240,
    renderCell: ({ value }) => renderCitiesCell(value),
  },
]
